import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import Sidebar from "@/components/layout/Sidebar";
import DefaultLayout from "@/components/common/DefaultLayout";
import DashboardMain from "@/pages/dashboard/DashboardMain";
import Stats from "@/pages/dashboard/stats/Stats";
import Currency from "@/pages/dashboard/currency/Currency"
import AddCurrency from "@/pages/dashboard/currency/AddCurrency"
import Breadcrumb from "@/components/dashboard/common/Breadcrumb.vue";
import CommonPaginator from "@/components/dashboard/common/CommonPaginator"
import CommonTable from "@/components/dashboard/common/CommonTable"
import CommonTableStore from "@/components/dashboard/common/CommonTableStore";
import Pagination from 'vue-pagination-2'
import UpdateCurrency from "@/pages/dashboard/currency/UpdateCurrency";
import PaymentMethod from "@/pages/dashboard/payment-method/PaymentMethod";
import AddPayment from "@/pages/dashboard/payment-method/AddPayment";
import UpdatePayment from "@/pages/dashboard/payment-method/UpdatePayment";
import CurrencyPayment from "@/pages/dashboard/currency-payments/CurrencyPayment";
import CurrencyPaymentAdd from "@/pages/dashboard/currency-payments/AddCurrencyPayment";
import CurrencyPaymentUpdate from "@/pages/dashboard/currency-payments/UpdateCurrencyPayment";
import Privilege from "@/pages/dashboard/privilege/Privilege";
import AddPrivilege from "@/pages/dashboard/privilege/AddPrivilege";
import UpdatePrivilege from "@/pages/dashboard/privilege/UpdatePrivilege";
import Group from "@/pages/dashboard/group/Group.vue";
import AddGroup from "@/pages/dashboard/group/AddGroup.vue";
import UpdateGroup from "@/pages/dashboard/group/UpdateGroup.vue";
import UpdateDefaultStatus from "@/pages/dashboard/group/UpdateDefaultStatus.vue";
import Loader from "@/components/common/Loader.vue";
import AuthMain from "@/pages/auth/AuthMain";
import Login from '@/pages/auth/Login'
import AuthLogo from "@/components/auth/logo/AuthLogo";
import MerchantDetails from "@/pages/dashboard/merchant/MerchantDetails";
import MerchantUpdateStatusModal from "@/pages/dashboard/merchant/MerchantUpdateStatusModal";
import Revenue from "@/pages/dashboard/revenue/Revenue";
import RevenueSummary from "@/pages/dashboard/revenue/RevenueSummary";
import AggregateSettlement from "@/pages/dashboard/settlements/aggregate/AggregateSettlement";
import CreateAggregateSettlement from "@/pages/dashboard/settlements/aggregate/CreateAggregateSettlement";
import ConfirmationModal from "@/components/common/modals/ConfirmationModal"
import AggregateSettlementDetail from "@/pages/dashboard/settlements/aggregate/AggregateSettlementDetail"
import ProcessSettlementModal from "@/pages/dashboard/settlements/ProcessSettlementModal"
import MakeAdjustment from "@/pages/dashboard/adjustment/MakeAdjustment";
import VpAccounts from "@/pages/dashboard/vp-accounts/VpAccounts"
import SelectOptions from "@/components/common/SelectOptions"
import TransactionDetails from "@/pages/dashboard/transactions/TransactionDetails";
import PaymentMethodSettings from "@/components/common/PaymentMethodSettings";
import NewBreadcrumb from "@/components/common/NewBreadcrumb";
import LoadMoreCommonTable from "@/components/dashboard/common/LoadMoreCommonTable";
import ProcessModal from "@/pages/dashboard/transactions/ProcessModal";
import CaseManagment from "@/pages/dashboard/case-management/CaseManagment"

// register components
export const registerComponents = (Vue) => {

    /*
    |--------------------------------------------------------------------------
    | Third Party Components Registration
    |--------------------------------------------------------------------------
    |
    | Register Your third party Components Here
    |
    */

    // pagination component registration starts
    Vue.component('Pagination', Pagination);
    // pagination component registration ends

    /*
    |--------------------------------------------------------------------------
    | Layout Components Registration
    |--------------------------------------------------------------------------
    |
    | Register Your Main Layout Components Here
    |
    */

    Vue.component('Header', Header);
    Vue.component('Sidebar', Sidebar);
    Vue.component('Footer', Footer);


    /*
   |--------------------------------------------------------------------------
   | Common Components Registration
   |--------------------------------------------------------------------------
   |
   | Register Your Common Components Here
   |
   */

    Vue.component('DefaultLayout', DefaultLayout);
    Vue.component('Loader', Loader);
    Vue.component('SelectOptions', SelectOptions);
    Vue.component('PaymentMethodSettings', PaymentMethodSettings);
    Vue.component('NewBreadcrumb', NewBreadcrumb);

    /*
   |--------------------------------------------------------------------------
   | Error Page Registration
   |--------------------------------------------------------------------------
   |
   | Register Your Error Pages Here
   |
   */

    /*
    |--------------------------------------------------------------------------
    | Pages Components Registration
    |--------------------------------------------------------------------------
    |
    | Register Your Pages Components Here
    |
    */

    /*
     * dashboard registration starts*/

    Vue.component('DashboardMain', DashboardMain);

    // dashboard common components registration starts
    Vue.component('Breadcrumb', Breadcrumb);
    Vue.component('CommonTable', CommonTable);
    Vue.component('CommonTableStore', CommonTableStore);
    Vue.component('LoadMoreCommonTable', LoadMoreCommonTable);
    Vue.component('CommonPaginator', CommonPaginator);
    Vue.component('ConfirmationModal', ConfirmationModal);
    // dashboard common components registration ends

    // stats registration starts
    Vue.component('Stats', Stats);
    // stats registration ends

    // currency registration starts
    Vue.component('Currency', Currency);
    Vue.component('AddCurrency', AddCurrency);
    Vue.component('UpdateCurrency', UpdateCurrency);
    // currency registration ends

    // Payment Method registration starts
    Vue.component('PaymentMethod', PaymentMethod);
    Vue.component('AddPayment', AddPayment);
    Vue.component('UpdatePayment', UpdatePayment);
    // Payment Method registration ends

    // Currency Payment Method registration starts
    Vue.component('CurrencyPayment', CurrencyPayment);
    Vue.component('CurrencyPaymentAdd', CurrencyPaymentAdd);
    Vue.component('CurrencyPaymentUpdate', CurrencyPaymentUpdate);
    // Currency Payment Method registration ends

    // Privilege registration starts
    Vue.component('Privilege', Privilege);
    Vue.component('AddPrivilege', AddPrivilege);
    Vue.component('UpdatePrivilege', UpdatePrivilege);
    // Privilege registration ends

    // group registration starts
    Vue.component('UserRoles', Group);
    Vue.component('AddRole', AddGroup);
    Vue.component('UpdateRole', UpdateGroup);
    Vue.component('UpdateDefaultStatus', UpdateDefaultStatus);
    // group registration ends


    /*
     * auth registration starts*/
    Vue.component('AuthLogo', AuthLogo);
    Vue.component('AuthMain', AuthMain);
    Vue.component('Login', Login);
    /*
     * auth registration ends*/


    /*
     * merchant registration starts*/
    Vue.component('MerchantDetails', MerchantDetails);
    Vue.component('MerchantUpdateStatusModal', MerchantUpdateStatusModal);
    /*
     * merchant registration ends*/

    /*
     * revenue registration starts*/
    Vue.component('Revenue', Revenue);
    Vue.component('RevenueSummary', RevenueSummary);
    /*
     * revenue registration ends*/


    /*
     * settlement registration starts*/
    Vue.component('AggregateSettlement', AggregateSettlement);
    Vue.component('CreateAggregateSettlement', CreateAggregateSettlement);
    Vue.component('AggregateSettlementDetail', AggregateSettlementDetail);
    Vue.component('ProcessSettlementModal', ProcessSettlementModal);
    /*
     * settlement registration ends*/


    /*
     * MakeAdjustment registration starts*/
    Vue.component('MakeAdjustment', MakeAdjustment);
    /*
     * MakeAdjustment registration ends*/


    /*
     * VpAccounts registration starts*/
    Vue.component('VpAccounts', VpAccounts);
    /*
     * VpAccounts registration ends*/

    /*
     * TransactionDetails registration starts*/
    Vue.component('TransactionDetails', TransactionDetails);
    Vue.component('ProcessModal', ProcessModal);
    /*
     * TransactionDetails registration ends*/

    /*

    * CaseManagment registration starts*/
    Vue.component('CaseManagment', CaseManagment);
    /*
    * CaseManagment registration ends*/


}
